import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AppTranslateModule } from '@core/app-translate.module';
import { SnackBarModule } from '@feature/snack-bar/snack-bar.module';

import { NoAccessPanelComponent } from './no-access-panel.component';

export const imports: NgModule['imports'] = [
  FlexLayoutModule,
  MatButtonModule,
  MatCardModule,
  MatIconModule,
  SnackBarModule,
];

@NgModule({
  declarations: [NoAccessPanelComponent],
  imports: [...imports, CommonModule, AppTranslateModule],
  exports: [NoAccessPanelComponent],
})
export class NoAccessPanelModule {}
